/* eslint-disable */
  /**
   * Google Tag Manager -
   * Any analytics should go in this function.
   * @param {string} brand - This will be TB (TestBase) Or EP (Exampro)
   */
  const startGoogleTagManager = (brand) => {
    console.log('start gtm');
    (function(w,d,s,l,i){
      w[l] = w[l] || [];
      w[l].push({'gtm.start': new Date().getTime(), event: 'gtm.js'});
      var f = d.getElementsByTagName(s)[0], j = d.createElement(s), dl = l != 'dataLayer' ? '&l='+l : '';
      j.async = true;
      j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;
      f.parentNode.insertBefore(j, f);
    })
    (window,document,'script','dataLayer','GTM-5JX222P8');

    // add GA measurement ID to datalayer so we can attribute events to EP or TB GA setups
    let dataLayer = window.dataLayer || [];
    dataLayer.push({ measurement_id: (brand == 'TB' ? 'G-EMHM5W6B34' : 'G-DHFKW30WFC')});
    return true;
  };
  /* eslint-enable */

// Old ecommerce purchase function - replaced by sendPurchase
/*const sendGoogleTagEcommerce = (basket, order, site = "Doublestruck") => {
  console.log('sending ecommerce?');
  window.ga("require", "ec");
  const { MD5 } = order;
  const formattedBasket = basket.map(
    ({ productID, Name, price, family, packageQuantity = 1 }) => {
      return {
        name: Name,
        id: productID,
        price: Number(price),
        brand: "Google",
        category: family,
        variant: "",
        quantity: packageQuantity,
        coupon: ""
      };
    }
  );

  const getVAT = (price, vatApplicable) =>
  (price / 100) * (Number(vatApplicable) || 0);

  const total = basket.reduce(
    (prev, current) => {
      return {
        amount: prev.amount + Number(current.price),
        tax: prev.tax + getVAT(current.price, current.vatApplicable)
      };
    },
    { amount: 0, tax: 0 }
  );

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: "formsSale",
    ecommerce: {
      purchase: {
        actionField: {
          id: MD5, // Transaction ID. Required for purchases and refunds.
          affiliation: site,
          revenue: total.amount, // Total transaction value (incl. tax and shipping)
          tax: total.tax,
          shipping: "0",
          coupon: ""
        },
        products: formattedBasket
      }
    }
  });
  console.log('sent ecommerce?');
};*/


//send GA events for items being added/removed from basket
// Using item category and category 2 to store family and family ID e.g. 'Science' and  '9'
// Using item category 3 to store products in package where applicable 
const sendBasketUpdate = (item, event, brand) => {

  let basketItems = [];
  basketItems.push({
    item_id: item.productID,
    item_name: item.Name,
    affiliation: brand,
    index: 0,
    item_brand: brand,
    item_category: item.family,
    item_category2: item.familyID,
    item_category3: item.productNameList,
    price: item.price,
    quantity: 1
  });

  let dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: event,
    ecommerce: {
      currency: "GBP",
      value: item.price,
      items: basketItems
    }
  });
}

//send purchase events
const sendPurchase = (order, items, brand) => {

  let purchaseItems = [];
  let total = 0;
  let totalVAT = 0;
  //process basket into items and calc total and tax
  items.forEach(function(item, index){

    let pItem = {
      item_id: item.productID,
      item_name: item.Name,
      affiliation: brand,
      index: 0,
      item_brand: brand,
      item_category: item.family,
      item_category2: item.familyID,
      item_category3: item.productNameList,
      price: item.price,
      quantity: 1
    };

    if (item.additionalUsers > 0) {
      purchaseItems.push({
        item_id: item.productID + '-U',
        item_name: 'Additional User - ' + item.Name,
        affiliation: brand,
        index: 0,
        item_brand: brand,
        item_category: item.family,
        item_category2: item.familyID,
        item_category3: item.productNameList,
        price: item.extrauserprice,
        quantity: item.additionalUsers
      });
    }

    total += Number(item.price);
    totalVAT += ((item.price / 100) * (Number(item.vatApplicable) || 0));
    purchaseItems.push(pItem);

  });

  let dataLayer = window.dataLayer || [];
  dataLayer.push({ ecommerce: null });  // Clear the previous ecommerce object.
  dataLayer.push({
    event: "purchase",
    ecommerce: {
        transaction_id: order.MD5, // Transaction ID. Required for purchases and refunds.
        value: total,
        tax: totalVAT,
        currency: "GBP",
        items: purchaseItems
    }
});

} 

export { startGoogleTagManager, sendBasketUpdate, sendPurchase };
